<h2 #text [contentEditable]="isEditable" [class.mobile]="isMobile" (keydown.enter)="onSubmit()">{{ title }}</h2>
